// extracted by mini-css-extract-plugin
export default {"Tbody":"styles_Tbody__8YzHD"};